import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { UserService } from "../settings/user/user.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ReportService = {

    PreviewList: [],

    async getReportPreviewScreenName(screenName) {
        if (this.PreviewList.length === 0) {
            await this.getPreviewList(screenName);
        }

        let preview = this.PreviewList.filter(
            (x) => x.ScreenName === screenName
        );

        return new Promise(async (resolve) => {
            resolve({
                data: {
                    value: preview,
                },
            });
        });
    },

    async getPreviewList(screenName) {
        const requestScreenData = {
            url: "api/TransactionListReportPreview",
            select: [
                "AvailableForEmail",
                "AvailableForPDFPreview",
                "Parameters",
                "RecordID",
                "ReportDisplayName",
                "ScreenLayoutApplicationFeatureCode",
                "ScreenName",
                "Status",
                "TransactionCode",
            ],
            filter: `Status eq 'A' and ScreenName eq '${screenName}'`,
        };

        return new Promise(async (resolve, reject) => {
            try {
                var result = await ApiService.oDataGet(requestScreenData);
                this.PreviewList = result.data.value;
                resolve(result);
            } catch (error) {
                reject(error);
            }
        });
    },

    async getViewVariant(key) {
        const requestScreenData = {
            url: "api/ViewVariant",
            filter: `Code eq '${key}' and Username eq '${UserService.getUsername()}'`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async saveViewVariant(payload) {
        var url = "api/GridViewDefinition";

        return await ApiService.post(url, payload);
    },

    async getGridViewDefinitionByKeyAndUsername(key) {
        const requestScreenData = {
            url: `api/GridViewDefinition/${key}/${UserService.getUsername()}`,
            filter: `Inactive eq 'N'`,
            orderby: "Sequence asc",
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async duplicateViewVariant(gridViewDefinitionId) {
        var url = `api/GridViewDefinition/${gridViewDefinitionId}/Duplicate`;

        return await ApiService.post(url, {
            "NewName": ""
        });
    },

    async setSelectedTemplate(gridKey, payload) {
        var url = `api/GridViewDefinition/${gridKey}/SetSelectedTemplate`;

        return await ApiService.post(url, payload);

    },

    async renameViewVariant(variantId, payload) {
        var url = "api/GridViewDefinition";

        return await ApiService.patch(
            url,
            variantId,
            payload,
            "Guid"
        );
    },

    async deleteViewVariant(gridViewDefinitionId) {
        var url = `api/GridViewDefinition`;

        return await ApiService.delete(
            url,
            gridViewDefinitionId,
            "Guid"
        );
    },

    async getInstanceLevelSequence(gridKey) {
        const requestScreenData = {
            url: `api/GridViewDefinition/${gridKey}/EveryoneSequence`,
            orderby: "Sequence asc",
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async updatePersonalLevelSequence(gridKey, payload) {
        var url = `api/GridViewDefinition/${gridKey}/Resequence`;

        return await ApiService.post(url, payload);
    },

    async updateInstanceLevelSequence(gridKey, payload) {
        var url = `api/GridViewDefinition/${gridKey}/ResequenceEveryone`;

        return await ApiService.post(url, payload);
    },
}

export default ReportService;